import { Button, ButtonProps, freddyTheme } from '@coolblue-development/freddy';
import type { ComponentPropsWithoutRef } from 'react';

type SharedShoppingCardButtonProps = ButtonProps & {
  component?: 'a' | 'button';
} & ComponentPropsWithoutRef<'button'> &
  ComponentPropsWithoutRef<'a'>;

const SharedShoppingCardButton = (props: SharedShoppingCardButtonProps) => {
  const { component, ...buttonProps } = props;
  return (
    <Button
      {...buttonProps}
      component={component === 'a' ? 'a' : 'button'}
      sx={{ [freddyTheme.breakpoint.minWidth('md')]: { maxWidth: '25rem' } }}
    >
      {props.children}
    </Button>
  );
};

export default SharedShoppingCardButton;
